export const categories = {
  main: [
    '',
    'Bücher',
    'Kartografie',
    'Postkarten'
  ],
  subcategories: {
    books: [
      '',
      'Stadtführer',
      'Reiseführer',
      'Wanderführer',
      'Harz-Literatur',
      'Discover (english)',
      'Kurzführer'
    ],
    maps: [
      '',
      'Wanderkarten Harz',
      'Mountainbike-Karten Harz',
      'Fahrradkarten',
      'Stadtpläne',
      'Luchskarten',
      'Freizeitkarten'
    ]
  }
};



// WEBPACK FOOTER //
// ./src/assets/categories.ts